import "./thankYou.scss";
import { useState, useEffect } from "react";
import LunchOffer from "./LunchOffer";
import { Modal } from "@mui/material";
import axios from "axios";

export default function NewThankYou() {
  const [offerModal, setOfferModal] = useState(false);
  // const _url = "http://localhost:4100";
  const _url = "https://dev.pmwevents.com";

  // useEffect(() => {
  //   const url = new URLSearchParams(window.location.search);
  //   const customerId = url.get("customer_id");
  //   let _numberOfAttendees = url.get("attendee_num");
  //   _numberOfAttendees = parseInt(_numberOfAttendees);
  //   const lunch = url.get("lunch") === "true";
  //   let lunchCount;

  //   if (lunch || !customerId) {
  //     return;
  //   }

  //   //TODO: GET LUNCH NUMBER AND MAKE SURE MODAL ONLY APPEARS IF SPACE
  //   axios
  //     .get(`${_url}/sbc/sbc-lunch-count`)
  //     .then((res) => {
  //       lunchCount = parseInt(res.data.count) + _numberOfAttendees;
  //       if (lunchCount <= 150) {
  //         setOfferModal(true);
  //       } else {
  //         return;
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  return (
    <main className="confirmation-thank-you">
      <h2>Thank You! We can't wait to see you at SBC25 in November!</h2>
      <h4>Your email confirmation will be with you shortly</h4>
      {/* MODALS */}
      {/* <Modal open={offerModal}>
        <LunchOffer handleClose={setOfferModal} />
      </Modal> */}
    </main>
  );
}
